/*
  MissedUser.js
  -------------
  Purpose: This page provides an interface for tracking and managing users who have not engaged with the platform recently. It allows administrators to view, search, and analyze missed or inactive users for re-engagement purposes.

  Main Logic:
  - Fetches and displays a list of missed/inactive users with search and filtering capabilities.
  - Supports analysis and export of user data for re-engagement campaigns.
  - Integrates with API endpoints for user data operations.
  - Utilizes React hooks for state management and side effects.
  - Displays loading indicators and handles user feedback.
*/

/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import useCommonApi from "../hooks/common-api";
import Loader from "../components/Loader";
import moment from "moment";
import * as XLSX from "xlsx";

function MissedUser() {
  const navigate = useNavigate();
  const [search, setsearch] = useState("");
  const [loader, setloader] = useState(false);
  const { getBlogListGraphql, featureStatusBlog } = useCommonApi();
  const { state } = useLocation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [missedUser, setmissedUser] = useState([]);

  console.log(missedUser);
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) {
      return "";
    }
    return moment(dateTimeString).format("D MMMM, YYYY | hh:mm A");
  };
  const getPublishDate = (item) => {
    const formattedDate = item?.publish_date
      ? new Date(item?.publish_date).toISOString().split("T")[0]
      : "";
    return formattedDate;
  };
  const getMissedUserList = async () => {
    try {
      setloader(true);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/usermanage/missed_user_list`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("admin_user_token"),
        },
      });

      if (!response?.data?.error) {
        setmissedUser(response?.data?.missed_user);
      } else {
      }
    } catch (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("mtm_user_token");
        localStorage.removeItem("mtm_user_data");
        navigate("/");
        return;
      }
      if (error.code === "ECONNABORTED") {
        console.log("Request timed out");
      } else {
        console.log("An error occurred:", error);
      }
    } finally {
      setloader(false);
    }
  };
  const exportToExcel = () => {
    const tableData = missedUser.map((item, index) => ({
      SerialNumber: index + 1,
      Email: item?.email,
      City: item?.city,
      IPAddress: item?.ip_address,
      IPCountry: item?.ip_contry,
      UserCount: item?.user_count,
      LastUpdatedAt: formatDateTime(item?.updatedAt),
      PageURL: item?.page_name,
    }));
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MissedUsers");

    // Export to Excel file
    XLSX.writeFile(workbook, "missed_users_data.xlsx");
  };
  useEffect(() => {
    getMissedUserList();
  }, []);

  return (
    <>
      <Container fluid>
        <Row className="mt-2">
          <Col sm={12} className="">
            <div className="d-flex align-items-center my-2">
              <h2 className="fw-700 fs-30 ">Missed User</h2>
              <div className="ms-auto">
                <button
                  onClick={exportToExcel}
                  className="grd-btn rounded-pill mx-2"
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="normal-tbl mt-3">
            <table>
              <tr className="tr-bg">
                <th>Serial Number</th>
                <th>Email</th>
                <th>City</th>
                <th>IP Address</th>
                <th>IP Country</th>
                <th>User Count</th>
                <th>Last Updated At</th>
                <th>Page URL</th>
              </tr>
              {loader && (
                <tr>
                  <td colSpan={6} className="text-center">
                    <Loader />
                  </td>
                </tr>
              )}
              {missedUser?.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item?.email}</td>
                  <td>{item?.city}</td>
                  <td>{item?.ip_address}</td>
                  <td>{item?.ip_contry}</td>
                  <td>{item?.user_count}</td>
                  <td>{formatDateTime(item?.updatedAt)}</td>
                  <td>
                    <a href={item?.page_name} rel="noreferrer" target="_blank">
                      {item?.page_name}
                    </a>{" "}
                  </td>
                </tr>
              ))}
            </table>
          </Col>
        </Row>
      </Container>
      {/*  Modal  */}
      <Modal size="" show={show} onHide={handleClose} centered animation={true}>
        <Modal.Header className="border-0 " closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h5 className="fw-600 fs-20 text-center">
            Choose allowed features for ｛Customer Name｝
          </h5>
          <div className="d-flex justify-content-center mt-3">
            <div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheck1"
                />
                <label className="form-check-label" for="flexCheck1">
                  Dashboard
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheck2"
                />
                <label className="form-check-label" for="flexCheck2">
                  Tracking
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheck3"
                />
                <label className="form-check-label" for="flexCheck3">
                  SKU Cost Footprint
                </label>
              </div>
            </div>
          </div>
          <div className="text-center pb-3">
            <button
              typeof="button"
              className="normal-btn px-4 rounded-pill me-4"
            >
              Cancel
            </button>
            <button
              typeof="button"
              className="normal-btn px-4 rounded-pill me-4"
            >
              Grant Access
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MissedUser;
